export default {
  // Layout
  layout: {
    maxWidth: '1440px',
    paddingInline: '2vw',
    ratio: [3, 2],
  },
  // Border radius
  borderRadius: {
    xsmall: '0.2em',
    small: '0.3em',
    medium: '1em',
    large: '1.5em',
    xlarge: '3em',
  },
  // New space object (https://chakra-ui.com/docs/styled-system/theming/theme?scroll=true#spacing)
  space: {
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem', // 24px
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
  },
  // Spacing
  spacing: {
    xsmall: '0.25rem',
    small: '0.5rem',
    default: '1rem',
    medium: '1.5rem',
    large: '2rem',
    xlarge: '3rem',
    xxlarge: '4rem',
    xxxlarge: '5rem',
  },
  // Image
  image: {
    borderRadius: '6px',
    boxShadow: 'rgba(0, 0, 0, 0.25) 0px 25px 50px -12px',
  },
  transition: {
    duration: '256ms',
    func: 'ease-in-out',
  },
  shadow: {
    sm: '0px 6px 20px rgba(0, 0, 0, 0.2)',
  },
};
